import $http from '@/api/index'

/*选择接收方
 *@method getUserByCompany
 *@return 人员或服务台
 */
export function getReceiver(userId, keyWord) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetAllUserAndServerCenterViaAuthority',
    requestType: 2
  }
  let params = {
    userId: userId,
    input: ''
  }
  if (keyWord != '') {
    params.input = keyWord
  }
  return $http(getUrl, params)
}
/*选择接收方
 *@method getUserByCompany
 *@return 人员或服务台
 */
export function GetAllContactTaskStakeholder(userId, keyWord, tag) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetAllContactTaskStakeholder',
    requestType: 2
  }
  let params = {
    userId: userId,
    keyword: '',
    tag: tag
  }
  if (userId == '') {
    params.userId = '4923'
  }
  if (keyWord != '') {
    params.keyword = keyWord
  }
  if (tag == '') {
    params.tag = 0
  }
  return $http(getUrl, params)
}
/*选择特定机构下人员
 *@method getUserByCompany
 *@return 人员
 */
export function getUserByCompany(userId, companyExId, keyWord, tag) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetCompanyDeptUserTree',
    requestType: 2
  }
  let params = {
    userId: userId,
    companyExId: companyExId,
    keyword: '',
    tag: tag
  }
  if (tag == '') {
    params.tag = 0
  }
  if (userId == '') {
    params.userId = 'super'
  }
  if (keyWord != '') {
    params.keyword = keyWord
  }
  return $http(getUrl, params)
}
/*选择所有人员
 *@method getUserByCompany
 *@return 人员
 */
export function getAllUser(userId, keyWord, tag, companyId, deptId) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetAllCompanyDeptUserTree',
    requestType: 2
  }
  let params = {
    userId: userId,
    keyword: '',
    tag: tag,
    companyId: companyId,
    deptId: deptId
  }
  if (tag == '') {
    params.tag = 0
  }
  if (userId == '') {
    params.userId = 'super'
  }
  if (keyWord != '') {
    params.keyword = keyWord
  }
  return $http(getUrl, params)
}
/*按用户自定义分组获取人员树
 *@method getUserByCompany
 *@return 人员
 */
export function GetUserTreeByCustomerGroup(userId, keyWord) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetUserTreeByCustomerGroup',
    requestType: 2
  }
  let params = {
    userId: userId,
    keyword: ''
  }
  if (userId == '') {
    params.userId = 'super'
  }
  if (keyWord != '') {
    params.keyword = keyWord
  }
  return $http(getUrl, params)
}
